module.exports = __webpack_public_path__ + "img/ertiga-xl7-magma.7bed4c0c.png";